import React from 'react';
import { styled } from 'linaria/react';
import Image from '@jetshop/ui/Image';
import { theme } from '../Theme';
import { Above } from '@jetshop/ui/Breakpoints';
import { useQuery } from 'react-apollo';
import STLProducts from './STLProducts.gql';
import { SliderWithButtons } from '../ui/SharedSlider';
import { ProductCard } from '../CategoryPage/ProductCard';
import QuickBuyFlyout, { QuickBuyTrigger } from './QuickBuyFlyout';

const Wrapper = styled('div')`
  display: flex;
  width: 100%;
  max-width: 80rem;
  margin: auto;

  h3 {
    color: #000;
    font-family: ${theme.fonts.primary};
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 100% */
    padding: 16px;
  }

  ${theme.below.lg} {
    max-width: 100%;
    width: 100%;
    flex-direction: column;
  }

  &.STL-slider {
    display: flex;
    flex-direction: column;
    list-style: none;
    .slider-wrapper {
      display: flex;
    }
    .hero-wrapper {
      width: 30%;
    }
    .slider-wrapper-inner {
      width: 70%;
      padding: 0 40px;
    }
    .main-name {
      padding: 0;
    }
    .mainrow-wrapper {
      padding-bottom: 10px;
    }
    .slick-track {
      top: 20px;
    }
  }
`;

const HeroWrapper = styled('div')`
  position: relative;
  button {
    position: absolute;
    bottom: 16px;
    right: 50%;
    transform: translateX(50%);
    font-family: ${theme.fonts.primary};
    color: #000;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: 15px; /* 125% */
    width: max-content;
    padding: 0 60px;
    height: 40px;
    background-color: #fff;
  }
`;

const StyledButton = styled('button')`
  position: absolute;
  bottom: 16px;
  right: 50%;
  transform: translateX(50%);
  font-family: ${theme.fonts.primary};
  color: #000;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 15px;
  width: max-content;
  padding: 0 60px;
  height: 40px;
  background-color: #fff;
`;

export const PDPShopTheLookHero = ({ image }) => {
  const imageSizes = [1, 1, 1, 300, 600];

  return (
    <QuickBuyTrigger>
      {({ onClick }) => (
        <HeroWrapper>
          <Image
            src={image}
            alt={'shop the look'}
            aspect="1:1"
            sizes={imageSizes}
          />
          <StyledButton onClick={onClick}>
            VELG STÖRELSE OG LEGG I HANDLEKURV
          </StyledButton>
        </HeroWrapper>
      )}
    </QuickBuyTrigger>
  );
};

export const PDPShopTheLook = ({ image, products }) => {
  const { data, loading, error } = useQuery(STLProducts, {
    variables: {
      articles: products
    },
    errorPolicy: 'ignore'
  });

  if (loading) return null;
  if (error) return null;
  if (!data?.products?.length) return null;

  return (
    <>
      <Above breakpoint="lg">
        {matches =>
          matches ? (
            <Wrapper className="STL-slider">
              <h3>Shoppa stilen</h3>
              <div className="slider-wrapper">
                <div className="hero-wrapper">
                  <PDPShopTheLookHero image={image} />
                </div>
                <div className="slider-wrapper-inner">
                  <SliderWithButtons
                    desktopSlides={3}
                    mobileSlides={2}
                    arrowTopPosition={'38%'}
                  >
                    {data.products.map(product => (
                      <ProductCard key={product.id} product={product} />
                    ))}
                  </SliderWithButtons>
                </div>
              </div>
              <QuickBuyFlyout products={data.products} />
            </Wrapper>
          ) : (
            <Wrapper>
              <h3>Shoppa stilen</h3>
              <PDPShopTheLookHero image={image} />
              <QuickBuyFlyout products={data.products} />
            </Wrapper>
          )
        }
      </Above>
    </>
  );
};
